/**
 * A one-visit hand-off from My work's New personal task to the task page: open
 * the new task's current stage with its instructions ready to type (Jeremy,
 * 1 Nov 2026, F171). sessionStorage, so it never outlives the tab, and read
 * once, so a later visit to the same task opens it normally.
 */
const KEY = "fieldpath:openInstructions";

export function openInstructionsOnArrival(taskId: string): void {
  try {
    window.sessionStorage.setItem(KEY, taskId);
  } catch {
    // Storage refused (private mode): the task simply opens as usual.
  }
}

/** True once, on the first arrival at the task this was set for. */
export function takeOpenInstructions(taskId: string): boolean {
  try {
    if (window.sessionStorage.getItem(KEY) !== taskId) return false;
    window.sessionStorage.removeItem(KEY);
    return true;
  } catch {
    return false;
  }
}
